import React, { useEffect, useState } from 'react';
import { Checkbox } from 'rsuite';
import { Button, Modal } from '@nsi-advisory-services/components';

// Where the employee makes the matching change on their own provider account.
// server/services/retirementNotificationService.js holds its own copy for the
// notice payroll receives - client and server deploy separately, so the two are
// duplicated with a pointer on each rather than shared.
export const EMPOWER_URL =
  'https://participant.empower-retirement.com/participant/home/#/dashboard/retirement-income';

// Shown the moment a retirement election is saved.
//
// Saving here changes what payroll deducts. It does NOT change anything at the
// provider - Empower is a separate system with no connection to this one - so
// an employee who stops at the save has done half a job and will not find out
// until a statement says something they did not expect. This is the only place
// that gap is visible, so the modal insists on being read: no close button, no
// backdrop dismiss, no escape key, and the way out is the checkbox.
//
// Part of the company-specific payroll module; see config/payrollFeature.js.
export default function RetirementEmpowerModal({ open, onConfirm }) {
  const [acknowledged, setAcknowledged] = useState(false);

  // A fresh save is a fresh acknowledgement. Reusing the last one would let a
  // second change through on the strength of the first.
  useEffect(() => {
    if (open) setAcknowledged(false);
  }, [open]);

  return (
    <Modal
      open={open}
      size="xs"
      backdrop="static"
      keyboard={false}
      onClose={() => {}}
    >
      <Modal.Header closeButton={false}>
        <Modal.Title>One more step in Empower</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          Your election is saved here, which is what payroll will deduct. It does
          not reach Empower on its own - you have to make the same change on your
          account there.
        </p>

        <p className="mt-3">
          <a
            href={EMPOWER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bdc-btn bdc-btn--sm bdc-btn--primary"
          >
            <i className="bi bi-box-arrow-up-right" aria-hidden="true" />
            Open Empower
          </a>
        </p>

        {/* Opens in a new tab, so going to do it does not throw away this
            modal - the confirmation is still here on the way back. */}
        <div className="mt-4">
          <Checkbox
            checked={acknowledged}
            onChange={(_value, checked) => setAcknowledged(checked)}
          >
            I have updated my contribution in Empower.
          </Checkbox>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="primary"
          onClick={onConfirm}
          disabled={!acknowledged}
        >
          Done
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
